export default __webpack_public_path__ + "static/media/Footer Adornment.b344a3e1.svg";